export { default as React } from 'react'
export { default as PropTypes } from 'prop-types'
export { connect as connectFela } from 'react-fela'
